<div class="" *ngFor="let recommendation of recommendationsList" [innerHTML]="recommendation.content"></div>
